'use client';

import { t } from 'i18next';
import { useForm } from 'react-hook-form';
import { useState, useEffect } from 'react';
import { zodResolver } from '@hookform/resolvers/zod';

import { Box, Button, Typography } from '@mui/material';

// import { OTPSchema } from 'src/utils/validations';
import { USER_ID_STORAGE_KEY } from 'src/utils/constants';

import { useResendOTP } from 'src/api/useLogin';

import { Form, Field } from 'src/components/hook-form';

import { OTPCountdownTimer } from './otp-timer';
import { useLocale } from 'src/locales';
import { createSchemas } from 'src/utils/use-validations';

export function LoginOTP({ open, onClose, submitLoginOTP, loading, mobileNumber }) {
  const { t } = useLocale();
  const { OTPSchema } = createSchemas();

  const [showTimer, setShowTimer] = useState(false);
  const [timerKey, setTimerKey] = useState(0);
  const defaultValues = {
    otp: '',
  };

  const { mutateAsync: resendOTP } = useResendOTP();

  const userID = sessionStorage.getItem(USER_ID_STORAGE_KEY);

  const methods = useForm({
    resolver: zodResolver(OTPSchema),
    defaultValues,
    mode: 'all',
  });

  const {
    handleSubmit,
    watch,
    setValue,
    reset,
    formState: { isSubmitting, isValid },
  } = methods;

  useEffect(() => {
    if (open) {
      reset();
      setShowTimer(true);
    }
  }, [open, reset]);

  const onSubmit = handleSubmit(async (data) => {
    submitLoginOTP({
      otp: data?.otp || '',
      mobileNumber: mobileNumber || '',
      userID: userID || '',
    });
  });

  const handleResendOTP = () => {
    setTimerKey((prev) => prev + 1);
    methods.reset();
    resendOTP({ mobileNumber, userID });
  };

  return (
    <Form methods={methods} onSubmit={onSubmit}>
      <Box sx={{ my: 2 }}>
        <Typography sx={{ textAlign: 'center' }}>
          {t('OTP_has_been_send_to')} {mobileNumber}
        </Typography>
        <Box sx={{ textAlign: 'center', my: 3 }}>
          {showTimer && <OTPCountdownTimer key={timerKey} />}
        </Box>
        <Field.Text
          required
          name="otp"
          label={t('Enter_OTP')}
          inputStyle={{ fontWeight: '900', letterSpacing: 20, fontSize: 16 }}
          maxLength={4}
        />
        <Button
          fullWidth
          color="primary"
          size="large"
          type="submit"
          variant="contained"
          loading={loading}
          disabled={isSubmitting}
          // loadingIndicator="Logging in..."
          sx={{
            '& .MuiCircularProgress-root': {
              color: '#0d9d57', // change loader colour here
              width: '20px !important',
              height: '20px !important',
            },
            my: 3,
          }}
        >
          {t('Login')}
        </Button>
        <Typography variant="body2" sx={{ textAlign: 'center' }}>
          {t('Did_not_received')} ? ?{' '}
          <Typography
            component="span"
            role="button"
            onClick={handleResendOTP}
            sx={{ color: '#0d9d57', cursor: 'pointer' }}
          >
            {t('Resend_OTP')}
          </Typography>
        </Typography>
      </Box>
    </Form>
  );
}
